import React from 'react';
import './Signup.css';
import FadeIn from 'react-fade-in';


import { Seater } from './Seater';



export class SignupForm extends React.Component {
  constructor(props) {
    super(props);



    this.state = {

      p1: { firstName: "", lastName: "", phone: "", email: "", age: "", special: "", rowNum: 0, seatNum: 0, foodTicket: false, paid: false, arrived: false, id: 1 },
      p2: { firstName: "", lastName: "", phone: "", email: "", age: "", special: "", rowNum: 0, seatNum: 0, foodTicket: false, paid: false, arrived: false, id: 2 },
      p3: { firstName: "", lastName: "", phone: "", email: "", age: "", special: "", rowNum: 0, seatNum: 0, foodTicket: false, paid: false, arrived: false, id: 3 },
      p4: { firstName: "", lastName: "", phone: "", email: "", age: "", special: "", rowNum: 0, seatNum: 0, foodTicket: false, paid: false, arrived: false, id: 4 },
      p5: { firstName: "", lastName: "", phone: "", email: "", age: "", special: "", rowNum: 0, seatNum: 0, foodTicket: false, paid: false, arrived: false, id: 5 },

      numPersonArray: [],

      enableSubmit: false,
      isSent: false,
      sendStatus: false,

      validateReason: "",

      setNumPersons: 0,

      emailRegex: "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?",
      containsNoNumbersRegex: "\\d"

    }

    //BINDINGS

    this.handleFormChangeP1 = this.handleFormChangeP1.bind(this);
    this.handleFormChangeP2 = this.handleFormChangeP2.bind(this);
    this.handleFormChangeP3 = this.handleFormChangeP3.bind(this);
    this.handleFormChangeP4 = this.handleFormChangeP4.bind(this);
    this.handleFormChangeP5 = this.handleFormChangeP5.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.validateSubmit = this.validateSubmit.bind(this);
    this.submit = this.submit.bind(this);
    this.backToForm = this.backToForm.bind(this);
    this.devAutofill = this.devAutofill.bind(this);

  }

  componentDidMount() {
    this.setState({
      p1: Object.assign({}, this.state.p1, { email: this.props.p1Email }), function() {
      }
    });
  }



  submit(e) {
    e.preventDefault();

    this.forceUpdate();

    this.setState({ validateReason: "" });

    if (this.props.numPersons >= 1) {
      let isValid = this.validateSubmit(this.state.p1);
      if (isValid === false) {
        alert("Deltaker 1 er ikke riktig utfylt. " + this.state.validateReason);
        return;
      }
    }
    if (this.props.numPersons >= 2) {
      let isValid = this.validateSubmit(this.state.p2);
      if (isValid === false) {
        alert("Den 2. deltakeren er ikke riktig utfylt. " + this.state.validateReason);
        return;
      }
    }
    if (this.props.numPersons >= 3) {
      let isValid = this.validateSubmit(this.state.p3);
      if (isValid === false) {
        alert("Den 3. deltakeren er ikke riktig utfylt. " + this.state.validateReason);
        return;
      }
    }
    if (this.props.numPersons >= 4) {
      let isValid = this.validateSubmit(this.state.p4);
      if (isValid === false) {
        alert("Den 4. deltakeren er ikke riktig utfylt. " + this.state.validateReason);
        return;
      }
    }
    if (this.props.numPersons >= 5) {
      let isValid = this.validateSubmit(this.state.p5);
      if (isValid === false) {
        alert("Den 5. deltakeren er ikke riktig utfylt. " + this.state.validateReason);
        return;
      }
    }



    this.setState({ setNumPersons: this.props.numPersons });
    this.setState({ isSent: true });
  }

  //Handlechange on the dropdown of number of people to sign up
  handleNumChange(e) {
    this.props.changeNumPersons(e.target.value);

  }

  //Handles the changing form values before submit
  handleFormChangeP1(e) {

    if (e.target.name === "firstName" || e.target.name === "lastName") {
      e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
    }

    //We must handle checkboxes with e.target.checked
    if (e.target.name === "foodTicket") {
      this.setState({
        p1: Object.assign({}, this.state.p1, { foodTicket: e.target.checked }), function() {
        }
      });
      this.validateForm();
    }
    else {

      this.setState({
        p1: Object.assign({}, this.state.p1, { [e.target.name]: e.target.value }), function() {
        }
      });

      this.validateForm();
    }

  }
  handleFormChangeP2(e) {
    if (e.target.name === "firstName" || e.target.name === "lastName") {
      e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
    }

    //We must handle checkboxes with e.target.checked
    if (e.target.name === "foodTicket") {
      this.setState({
        p2: Object.assign({}, this.state.p2, { foodTicket: e.target.checked }), function() {
        }
      });
      this.validateForm();
    }
    else {

      this.setState({
        p2: Object.assign({}, this.state.p2, { [e.target.name]: e.target.value }), function() {
        }
      });

      this.validateForm();
    }

  }
  handleFormChangeP3(e) {
    if (e.target.name === "firstName" || e.target.name === "lastName") {
      e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
    }

    //We must handle checkboxes with e.target.checked
    if (e.target.name === "foodTicket") {
      this.setState({
        p3: Object.assign({}, this.state.p3, { foodTicket: e.target.checked }), function() {
        }
      });
      this.validateForm();
    }
    else {

      this.setState({
        p3: Object.assign({}, this.state.p3, { [e.target.name]: e.target.value }), function() {
        }
      });

      this.validateForm();
    }

  }
  handleFormChangeP4(e) {
    if (e.target.name === "firstName" || e.target.name === "lastName") {
      e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
    }
    //We must handle checkboxes with e.target.checked
    if (e.target.name === "foodTicket") {
      this.setState({
        p4: Object.assign({}, this.state.p4, { foodTicket: e.target.checked }), function() {
        }
      });
      this.validateForm();
    }
    else {

      this.setState({
        p4: Object.assign({}, this.state.p4, { [e.target.name]: e.target.value }), function() {
        }
      });

      this.validateForm();
    }

  }
  handleFormChangeP5(e) {
    if (e.target.name === "firstName" || e.target.name === "lastName") {
      e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
    }
    //We must handle checkboxes with e.target.checked
    if (e.target.name === "foodTicket") {
      this.setState({
        p5: Object.assign({}, this.state.p5, { foodTicket: e.target.checked }), function() {
        }
      });
      this.validateForm();
    }
    else {

      this.setState({
        p5: Object.assign({}, this.state.p5, { [e.target.name]: e.target.value }), function() {
        }
      });

      this.validateForm();
    }

  }

  // Dev mode autofill function
  devAutofill() {
    const generatePerson = (id) => {
      const firstNames = ['Alex', 'Emma', 'Liam', 'Olivia', 'Noah', 'Ava', 'William', 'Sophia', 'James', 'Isabella'];
      const lastNames = ['Hansen', 'Olsen', 'Andersen', 'Larsen', 'Pedersen', 'Nilsen', 'Kristiansen', 'Jensen', 'Karlsen', 'Johnsen'];

      const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
      const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
      const age = Math.floor(Math.random() * 30) + 15; // Age between 15-45
      const phone = `${Math.floor(Math.random() * 90000000) + 10000000}`; // 8-digit phone
      const email = `${firstName.toLowerCase()}.${lastName.toLowerCase()}@example.com`;

      return {
        firstName,
        lastName,
        phone,
        email,
        age: age.toString(),
        special: '',
        rowNum: 0,
        seatNum: 0,
        foodTicket: false,
        paid: false,
        arrived: false,
        id
      };
    };

    // Fill forms based on number of persons
    const numPersons = parseInt(this.props.numPersons);
    if (numPersons >= 1) this.setState({ p1: generatePerson(1) });
    if (numPersons >= 2) this.setState({ p2: generatePerson(2) });
    if (numPersons >= 3) this.setState({ p3: generatePerson(3) });
    if (numPersons >= 4) this.setState({ p4: generatePerson(4) });
    if (numPersons >= 5) this.setState({ p5: generatePerson(5) });

    // Validation will happen automatically when the form re-renders
    // No need to call validateForm() explicitly
  }

  //Validate form input
  validateForm() {
    for (let i = 0; i < this.state.numPersonArray.length; i++) {
      if (this.state.numPersonArray[i].firstName.length > 1 && this.state.numPersonArray[i].lastName.length > 1 && this.state.numPersonArray[i].phone.length > 6 && this.state.numPersonArray[i].phone > 999999 && this.state.numPersonArray[i].age.toString() > 0) {
        let re = new RegExp(this.state.emailRegex);
        if (re.test(this.state.numPersonArray[i].email)) {
          this.setState({ enableSubmit: true });
        }
        else {
          this.setState({ enableSubmit: false });
        }
      }
      else {
        this.setState({ enableSubmit: false });
      }
    }
  }


  validateSubmit(p) {


    //Firstname
    if (p.firstName.length < 1) {
      this.setState({ validateReason: "Vennligst fyll inn fornavn" });
      return false;
    }
    else {
      const check = new RegExp(this.state.containsNoNumbersRegex);
      const res = check.test(p.firstName);
      if (res) { //If contains a number
        this.setState({ validateReason: "Fornavn er ugyldig" });
        return false;
      }
    }

    //Lastname
    if (p.lastName.length < 1) {
      this.setState({ validateReason: "Vennligst fyll inn Etternavn" });
      return false;
    }
    else {
      const check = new RegExp(this.state.containsNoNumbersRegex);
      const res = check.test(p.lastName);
      if (res) { //If contains a number
        this.setState({ validateReason: "Etternavn er ugyldig" });
        return false;
      }
    }
    //Age
    if (p.age <= 1) {
      this.setState({ validateReason: "Alder er ugyldig" });
      return false;
    }
    if (isNaN(p.age)) {
      this.setState({ validateReason: "Alder er ugyldig" });
      return false;
    }


    //Telefon
    if (p.phone.trim() < 9999999) {
      this.setState({ validateReason: "Telefonnummer er ugyldig" });
      return false;
    }

    //EPOST
    let re = new RegExp(this.state.emailRegex);
    if (!re.test(p.email)) {
      this.setState({ validateReason: "Epost er ugyldig" });
      return false;
    }

    this.setState({ validateReason: "" });
    return true //If we pass all tests
  }


  backToForm() {
    this.setState({ isSent: false });
  }



  render() {


    let personArr = [];
    if (this.props.numPersons >= 1) {
      this.state.numPersonArray.push(this.state.p1);


      if (!this.state.numPersonArray.indexOf(this.state.p1.id) > -1) {
        this.state.numPersonArray.push(this.state.p1);
      }


      personArr.push(

        <div key={this.state.p1.id} name="key" value={this.state.p1.id} onChange={this.handleFormChangeP1} className="col col-centered signupCard">
          <form className="personForm">
            <h4>Deltaker 1</h4>
            <div className="card">
              Fornavn
      <input style={{padding: '4px'}} type="text" key={this.state.p1.id} name="firstName" autoComplete="given-name" value={this.state.p1.firstName} onChange={this.handleFormChangeP1} placeholder="Fornavn" />
              Etternavn
      <input style={{padding: '4px'}} type="text" name="lastName" autoComplete="family-name" value={this.state.p1.lastName} onChange={this.handleFormChangeP1} placeholder="Etternavn" />
              Alder
      <input style={{padding: '4px'}} type="text" name="age" value={this.state.p1.age} onChange={this.handleFormChangeP1} placeholder="Alder" />
              Telefon
      <input style={{padding: '4px'}} type="text" name="phone" autoComplete="tel-national" value={this.state.p1.phone} onChange={this.handleFormChangeP1} placeholder="Telefon" />
              Epost
      <input style={{padding: '4px'}} type="text" name="email" autoComplete="email" value={this.state.p1.email} onChange={this.handleFormChangeP1} placeholder="Epost" />
              <div>
                <p></p>
          {this.props.foodTicket !== false &&       <p>
                  <input type="checkbox" name="foodTicket" value={this.state.p1.foodTicket} onChange={this.handleFormChangeP1} /*defaultChecked={this.state.chkbox}  onChange={this.handleChangeChk}*/ />
                  <i> </i>Jeg ønsker matbillett
          </p> }
              </div>
              Spesielle hensyn?
      <textarea name="special" className="signupTextArea" value={this.state.p1.special} onChange={this.handleFormChangeP1} />
            </div>
          </form>
        </div>

      )
    }

    if (this.props.numPersons >= 2) {

      if (!this.state.numPersonArray.indexOf(this.state.p2.id) > -1) {
        this.state.numPersonArray.push(this.state.p2);
      }
      personArr.push(

        <div key={this.state.p2.id} name="key" value={this.state.p2.id} onChange={this.handleFormChangeP2} className="col col-centered signupCard">
          <form className="personForm">
            <h4>Deltaker 2</h4>
            <div className="card">
              Fornavn
      <input type="text" key={this.state.p2.id} name="firstName" autoComplete="given-name" value={this.state.p2.firstName} onChange={this.handleFormChangeP2} placeholder="Fornavn" />
              Etternavn
      <input type="text" name="lastName" autoComplete="family-name" value={this.state.p2.lastName} onChange={this.handleFormChangeP2} placeholder="Etternavn" />
              Alder
      <input type="text" name="age" value={this.state.p2.age} onChange={this.handleFormChangeP2} placeholder="Alder" />
              Telefon
      <input type="text" name="phone" autoComplete="tel-national" value={this.state.p2.phone} onChange={this.handleFormChangeP2} placeholder="Telefon" />
              Epost
      <input type="text" name="email" autoComplete="email" value={this.state.p2.email} onChange={this.handleFormChangeP2} placeholder="Epost" />
              <div>
                <p></p>
                {this.props.foodTicket !== false &&    <p>
                  <input type="checkbox" name="foodTicket" value={this.state.p2.foodTicket} onChange={this.handleFormChangeP2} /*defaultChecked={this.state.chkbox}  onChange={this.handleChangeChk}*/ />
                  <i> </i>Jeg ønsker matbillett
                </p> }
              </div>
              Spesielle hensyn?
      <textarea name="special" className="signupTextArea" value={this.state.p2.special} onChange={this.handleFormChangeP2} />
            </div>
          </form>
        </div>

      )
    }

    if (this.props.numPersons >= 3) {

      if (!this.state.numPersonArray.indexOf(this.state.p3.id) > -1) {
        this.state.numPersonArray.push(this.state.p3);
      }
      personArr.push(

        <div key={this.state.p3.id} name="key" value={this.state.p3.id} onChange={this.handleFormChangeP3} className="col col-centered signupCard">
          <form className="personForm">
            <h4>Deltaker 3</h4>
            <div className="card">
              Fornavn
      <input type="text" key={this.state.p3.id} name="firstName" autoComplete="given-name" value={this.state.p3.firstName} onChange={this.handleFormChangeP3} placeholder="Fornavn" />
              Etternavn
      <input type="text" name="lastName" autoComplete="family-name" value={this.state.p3.lastName} onChange={this.handleFormChangeP3} placeholder="Etternavn" />
              Alder
      <input type="text" name="age" value={this.state.p3.age} onChange={this.handleFormChangeP3} placeholder="Alder" />
              Telefon
      <input type="text" name="phone" autoComplete="tel-national" value={this.state.p3.phone} onChange={this.handleFormChangeP3} placeholder="Telefon" />
              Epost
      <input type="text" name="email" autoComplete="email" value={this.state.p3.email} onChange={this.handleFormChangeP3} placeholder="Epost" />
              <div>
                <p></p>
                {this.props.foodTicket !== false &&     <p>
                  <input type="checkbox" name="foodTicket" value={this.state.p3.foodTicket} onChange={this.handleFormChangeP3} /*defaultChecked={this.state.chkbox}  onChange={this.handleChangeChk}*/ />
                  <i> </i>Jeg ønsker matbillett
                </p> }
              </div>
              Spesielle hensyn?
      <textarea name="special" className="signupTextArea" value={this.state.p3.special} onChange={this.handleFormChangeP3} />
            </div>
          </form>
        </div>

      )
    }

    if (this.props.numPersons >= 4) {

      if (!this.state.numPersonArray.indexOf(this.state.p4.id) > -1) {
        this.state.numPersonArray.push(this.state.p4);
      }
      personArr.push(

        <div key={this.state.p4.id} name="key" value={this.state.p4.id} onChange={this.handleFormChangeP4} className="col col-centered signupCard">
          <form className="personForm">
            <h4>Deltaker 4</h4>
            <div className="card">
              Fornavn
      <input type="text" key={this.state.p4.id} name="firstName" autoComplete="given-name" value={this.state.p4.firstName} onChange={this.handleFormChangeP4} placeholder="Fornavn" />
              Etternavn
      <input type="text" name="lastName" autoComplete="family-name" value={this.state.p4.lastName} onChange={this.handleFormChangeP4} placeholder="Etternavn" />
              Alder
      <input type="text" name="age" value={this.state.p4.age} onChange={this.handleFormChangeP4} placeholder="Alder" />
              Telefon
      <input type="text" name="phone" autoComplete="tel-national" value={this.state.p4.phone} onChange={this.handleFormChangeP4} placeholder="Telefon" />
              Epost
      <input type="text" name="email" autoComplete="email" value={this.state.p4.email} onChange={this.handleFormChangeP4} placeholder="Epost" />
              <div>
                <p></p>
                {this.props.foodTicket !== false &&           <p>
                  <input type="checkbox" name="foodTicket" value={this.state.p4.foodTicket} onChange={this.handleFormChangeP4} /*defaultChecked={this.state.chkbox}  onChange={this.handleChangeChk}*/ />
                  <i> </i>Jeg ønsker matbillett
                </p> }
              </div>
              Spesielle hensyn?
      <textarea name="special" className="signupTextArea" value={this.state.p4.special} onChange={this.handleFormChangeP4} />
            </div>
          </form>
        </div>

      )
    }

    if (this.props.numPersons >= 5) {

      if (!this.state.numPersonArray.indexOf(this.state.p5.id) > -1) {
        this.state.numPersonArray.push(this.state.p5);
      }
      personArr.push(

        <div key={this.state.p5.id} name="key" value={this.state.p5.id} onChange={this.handleFormChangeP5} className="col col-centered signupCard">
          <form className="personForm">
            <h4>Deltaker 5</h4>
            <div className="card">
              Fornavn
      <input type="text" key={this.state.p5.id} name="firstName" autoComplete="given-name" value={this.state.p5.firstName} onChange={this.handleFormChangeP5} placeholder="Fornavn" />
              Etternavn
      <input type="text" name="lastName" autoComplete="family-name" value={this.state.p5.lastName} onChange={this.handleFormChangeP5} placeholder="Etternavn" />
              Alder
      <input type="text" name="age" value={this.state.p5.age} onChange={this.handleFormChangeP5} placeholder="Alder" />
              Telefon
      <input type="text" name="phone" autoComplete="tel-national" value={this.state.p5.phone} onChange={this.handleFormChangeP5} placeholder="Telefon" />
              Epost
      <input type="text" name="email" autoComplete="email" value={this.state.p5.email} onChange={this.handleFormChangeP5} placeholder="Epost" />
              <div>
                <p></p>
                {this.props.foodTicket !== false &&    <p>
                  <input type="checkbox" name="foodTicket" value={this.state.p5.foodTicket} onChange={this.handleFormChangeP5} /*defaultChecked={this.state.chkbox}  onChange={this.handleChangeChk}*/ />
                  <i> </i>Jeg ønsker matbillett
                </p> }
              </div>
              Spesielle hensyn?
      <textarea name="special" className="signupTextArea" value={this.state.p5.special} onChange={this.handleFormChangeP5} />
            </div>
          </form>

          <div className="spacer"> </div>
        </div>

      )
    }


    return (
      <FadeIn>
        <div className="SignupForm">
          {this.state.isSent === false && <div>
            <h2> Registrering </h2>
            <p> </p>
            <h5>Velg antall deltakere og fyll ut informasjonen</h5>
            <p>Om deltakeren ikke har telefon fylles foresattes telefonnummer inn istedet</p> </div>}



          {this.state.isSent === false && <div>
            <div className="signupNum">
              <h4>Antall deltakere</h4> <i></i>
              <select value={this.props.numPersons} onChange={this.handleNumChange.bind(this)}>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
            </div>

            {/* Dev mode autofill button - only show in development */}
            {process.env.NODE_ENV === 'development' && (
              <div style={{ margin: '10px 0', textAlign: 'center' }}>
                <button
                  type="button"
                  onClick={this.devAutofill}
                  style={{
                    backgroundColor: '#ff6b35',
                    color: 'white',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                >
                  🚀 Dev: Autofill Forms
                </button>
              </div>
            )}

            <div className="SignupForm">
              <div className="row">
                <div className="col col-centered">


                  {personArr}
                </div>



              </div>

            </div>
          </div>}
          {this.state.isSent === false && <button className="signupSend btn btno btn-danger back" onClick={this.props.setStartSignup}>Tilbake</button>}
          {this.state.isSent === false && <button className="back signupSend btn btno btn-info" onClick={this.submit.bind(this)} text="Til plassreservering">Til Plassreservasjon</button>}
          {this.state.isSent === true && <Seater guid={this.props.guid} backToForm={this.backToForm} p1={this.state.p1} p2={this.state.p2} p3={this.state.p3} p4={this.state.p4} p5={this.state.p5} setNumPersons={this.state.setNumPersons} priceNoFood={this.props.priceNoFood} priceWithFood={this.props.priceWithFood} foodTicketDisabled={this.props.foodTicket} />}





        </div>

      </FadeIn>


    );
  }
}

export default SignupForm;




// WEBPACK FOOTER //
// ./src/Components/Signup/SignupForm.js